import PopulateLogo from '@/core/icons/populateLogo';
import isNil from 'lodash/isNil';

type HeaderProps = {
  error?: string | null;
}

export default function Header({ error }: HeaderProps) {
  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-center pt-4">
          <PopulateLogo className="!w-[180px] !h-auto" />
        </div>
        <div className="text-center">
          {/* <h1 className="text-2xl md:text-3xl font-bold text-[#20B2AA] mb-3">Patient Portal</h1> */}
          <p className="text-black text-xl font-semibold">Welcome to Patient Portal</p>
        </div>

      </div>
      {/* Error Display */}
      {!isNil(error) && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-xs md:text-sm mb-6">
          {error}
        </div>
      )}
    </>
  );
}
